import { detectEnvironment } from '@/shared/lib/detectEnvironment';

/**
 * Generates the saved-filters config endpoint URL.
 * For staging: /config/saved-filters_staging
 * For production/other: /config/saved-filters
 *
 * @param id - Optional saved filter id to append (targets a single filter)
 * @returns The full saved-filters endpoint URL
 */
export const getSavedFiltersApiUrl = (id?: string): string => {
  const basePath =
    detectEnvironment() === 'staging' ? '/config/saved-filters_staging' : '/config/saved-filters';
  return id?.trim() ? `${basePath}/${id.trim()}` : basePath;
};
